export default __webpack_public_path__ + "static/media/black-olives.b937f2e5.jpg";